/* eslint-disable */
import React, { useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

// import Table from 'components/Table'
import Button from 'components/Button'
import ArrowLeftIcon from 'assets/icons/arrow-left-line'
import DownloadIcon from 'assets/icons/download-icon'
import TableSticky from 'features/TableSticky'

import {
  ExpandedTableHeader,
  ExpandedTableHeaderTitle,
  ExpandedTableLeftSide, ExpandedTableRightSide,
  // ExpandedTableWrapper,
  // ReportsTableWrapper,
  StickyTableWrapper
} from '../style'

const getTableHeight = (rows) => {
  if (!rows.length) {
    return '700px'
  }

  const tableHeight = rows.length * 48 + 65
  const screenHeightLimit = screen.height - 266

  return tableHeight > screenHeightLimit ? `${screenHeightLimit}px` : `${tableHeight}px`
}


const ExpandedReportsTable = ({ title, rows, columns, loading, totalNumber, resultsPerPage, changeResultsPerPage, download }) => {
  const history = useNavigate()
  const observer = useRef()

  const lastElementRef = useCallback((node) => {
    if (loading) {
      return
    }
    if (observer.current) {
      observer.current.disconnect()
    }
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        if (resultsPerPage < totalNumber) {
          return changeResultsPerPage({ value: resultsPerPage + 6 })
        }
      }
    })

    if (node) {
      observer.current.observe(node)
    }
  }, [rows])

  const goBack = () => {
    history('/reports')
    changeResultsPerPage({ value: 10 })
  }

  return (
    <>
      <ExpandedTableHeader>
        <ExpandedTableLeftSide>
          <Button onClick={goBack} height="40px" marginTop="16px">
            <ArrowLeftIcon />
            <FormattedMessage id='backToReports' />
          </Button>
        </ExpandedTableLeftSide>
        <ExpandedTableHeaderTitle>
          <FormattedMessage id={title} />
        </ExpandedTableHeaderTitle>
        <ExpandedTableRightSide>
          <Button type='primary' height='40px' marginTop="16px" onClick={download}>
            <DownloadIcon />
            <FormattedMessage id="download" />
          </Button>
        </ExpandedTableRightSide>
      </ExpandedTableHeader>
      {/*<ExpandedTableWrapper className='scroll'>*/}
      {/*  <ReportsTableWrapper activeTab={title} expanded={true}>*/}
      {/*    <Table*/}
      {/*      columns={columns}*/}
      {/*      rows={rows}*/}
      {/*      noClearFilter={true}*/}
      {/*      noResultMessage='noSitesMatchFilteringCriteria'*/}
      {/*      dataTest='speciesTab-list'*/}
      {/*      lastElementRef={lastElementRef}*/}
      {/*      height='unset'*/}
      {/*      overflow={false}*/}
      {/*      isLoading={loading}*/}
      {/*    />*/}
      {/*  </ReportsTableWrapper>*/}
      {/*</ExpandedTableWrapper>*/}
      <StickyTableWrapper>
        <TableSticky
          isLoading={loading}
          noResultMessage='noSitesMatchFilteringCriteria'
          height={getTableHeight(rows)}
          width="calc(100vw-128px)"
          columns={columns}
          data={rows}
          lastElementRef={lastElementRef}
        />
      </StickyTableWrapper>
    </>
  )
}

export default ExpandedReportsTable
